module.exports = __webpack_public_path__ + "static/img/fund5.c83ef17.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/fundClassify/fund5.png
// module id = mypN
// module chunks = 0